module.exports = __webpack_public_path__ + "frontend/images/homepage/carousel/desktop/4.png?de4a48ba354591018428169b3812d65a";